import type { ISEOProps } from "../types/core";

export const ForgotPasswordPageSEO: ISEOProps = {
  title: "Forgot Password - Sugar Cribs",
  description:
    "Reset your Sugar Cribs account password. Enter your email to receive password reset instructions.",
};
